import { FC } from 'react';

import { Responsive } from 'components/_basic/Responsive';

import { SubscriptionPlansMobileView } from './components';
import { SubscriptionPlansDesktopView } from './components/SubscriptionPlansDesktopView/SubscriptionPlansDesktopView';
import { ISubscriptionPlanLayoutProps } from './types';

export const SubscriptionPlansLayout: FC<ISubscriptionPlanLayoutProps> = (props) => {
  return (
    <>
      <Responsive mobile>
        <SubscriptionPlansMobileView {...props} />
      </Responsive>
      <Responsive aboveMobile>
        <SubscriptionPlansDesktopView {...props} />
      </Responsive>
    </>
  );
};
